import { PropsWithChildren, SyntheticEvent, useEffect } from 'react'

import CloseIcon from 'assets/icons/close.svg'

import { combineClassnames } from 'app/common/presentation'

import { Headline, IconButton } from 'components/'

import styles from './Modal.module.scss'

export interface ModalProps extends PropsWithChildren {
  actions?: JSX.Element
  className?: string
  contentClassName?: string
  onClose: () => void
  onSubmit?: (e: SyntheticEvent<HTMLFormElement>) => void
  open: boolean
  title: string
}

const Modal = ({
  actions,
  children,
  className,
  contentClassName,
  onClose,
  onSubmit,
  open,
  title,
}: ModalProps) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    if (open) {
      window.addEventListener('keydown', handleKeyDown)
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [open, onClose])

  return (
    open && (
      <div className={styles.modal} onClick={onClose}>
        <div
          className={combineClassnames(styles.container, className)}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={styles.header}>
            <Headline className={styles.title}>{title}</Headline>
            <IconButton icon={CloseIcon} onClick={onClose} small variant="tertiary" />
          </div>
          <form onSubmit={(e) => (onSubmit ? onSubmit(e) : e.preventDefault())}>
            <div className={combineClassnames(styles.content, contentClassName)}>{children}</div>
            {actions && <div className={styles.actions}>{actions}</div>}
          </form>
        </div>
      </div>
    )
  )
}

export default Modal
